import { Injectable }           from '@angular/core';
import { Observable }           from 'rxjs';
import { CanDeactivate,
         ActivatedRouteSnapshot,
         RouterStateSnapshot, 
         Router}  from '@angular/router';

import { ContactComponent } from '../project/ontology-editor/contact/contact.component';
import { FlowCreateComponent } from '../project/flow/flow-create/flow-create.component';
import { PromotionCreateComponent } from '../project/settings/promotion/promotion-create/promotion-create.component';
import { ProjectSettingsComponent } from '../project/settings/project-settings/project-settings.component';
import { NlpScriptingComponent } from '../project/settings/nlp-scripting/nlp-scripting.component';
import { ScriptingComponent } from '../project/settings/scripting/scripting.component';
import { RivescriptComponent } from '../project/settings/rivescript/rivescript.component';
import { DocumentScriptLibraryComponent } from '../project/settings/document-script-library/document-script-library.component';
import { DataTrackingService } from '../_services/data-tracking.service';
import { ConfirmationDialogService } from '../_services/confirmation-dialog.service';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<
                                                          ContactComponent |
                                                          FlowCreateComponent |
                                                          PromotionCreateComponent |
                                                          ProjectSettingsComponent |
                                                          NlpScriptingComponent | 
                                                          ScriptingComponent | 
                                                          RivescriptComponent |
                                                          DocumentScriptLibraryComponent > {    
    constructor(private dataTrackingService: DataTrackingService, private confirmationService: ConfirmationDialogService, private router: Router) {}

    canDeactivate(
        component: any,
        route: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        if (this.dataTrackingService.unsavedDataList.length > 0) {
            this.confirmationService.confirm('Unsaved Data Detected', 
                `Unsaved data is detected in ${this.dataTrackingService.unsavedDataList.join(', ')}. If you leave before saving, your changes will not be added. Do you want to continue?`,
                () => {
                    this.router.navigate([nextState.url])
                    this.dataTrackingService.removeAllUnsavedItem();
                }, 
                () => {}, true);
            return false;
        } else {
            return true;
        }
    }
}